import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { InvestigationsState } from '../../states/investigations.state';
import type { GetInvestigationByIdQuery } from './get-investigation-by-id.query';
import type { GetInvestigationByIdResult } from './get-investigation-by-id.result';

@Injectable({ providedIn: 'root' })
export class GetInvestigationByIdUseCase {
  private readonly _repository = inject(InvestigationsRepository);
  private readonly _state = inject(InvestigationsState);

  public execute(query: GetInvestigationByIdQuery, silent = false): Observable<GetInvestigationByIdResult> {
    if (!silent) {
      this._state.setLoadingInvestigation(true);
      this._state.setErrorLoadingInvestigation(null);
    }

    return this._repository.getInvestigationById(query.investigationId).pipe(
      tap((investigation) => {
        this._state.setSelectedInvestigation(investigation);
        if (!silent) {
          this._state.setLoadingInvestigation(false);
        }
      }),
      map((investigation) => ({ investigation })),
      catchError((error) => {
        const errorMessage = error.message || 'Failed to load investigation details';
        if (!silent) {
          this._state.setErrorLoadingInvestigation(errorMessage);
          this._state.setLoadingInvestigation(false);
          this._state.setSelectedInvestigation(null);
        }
        return throwError(() => error);
      }),
    );
  }
}
